import React, { useState, useEffect } from "react";
import { colors2, LoaderCircleV2, UI_BODY_SEMIBOLD_SM_DF } from "oolib";
const loadingText = [
  "Looking through your data…",
  "Finding patterns and connections…",
  "Pulling out the most relevant points…",
  "Almost ready with your insights…",
  "Finalizing your answer…",
];
export const LoadingText = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        if (prevIndex < loadingText.length - 1) {
          return prevIndex + 1;
        } else {
          clearInterval(interval);
          return prevIndex;
        }
      });
    }, 3000); // Change text every 3 seconds
    return () => clearInterval(interval);
  }, []);
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1.5rem 1fr", alignItems: "center", gap: "1.5rem" }}>
      <LoaderCircleV2 S isBlock />
      <div style={{ position: "relative", overflow: "hidden" }}>
        <UI_BODY_SEMIBOLD_SM_DF>{loadingText[currentIndex]}</UI_BODY_SEMIBOLD_SM_DF>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background: `linear-gradient(to right, transparent 0%, ${colors2.white} 20%, transparent 100%)`,
            animation: "gradientMove 2s cubic-bezier(0.4, 0.0, 0.2, 1) infinite",
            pointerEvents: "none",
          }}
        />
        <style>
          {`
            @keyframes gradientMove {
              from { left: -100%; }
              to { left: 100%; }
            }
          `}
        </style>
      </div>
    </div>
  );
};
